export default __webpack_public_path__ + "static/media-leaves-mobile-58db4e8b5c56d923fc2aeefe8eff34e3.png";